import { LitElement, css, unsafeCSS, html } from 'lit';
import Cookies from 'js-cookie';

import _styles from './CookiesAgreement.ce.scss';

export interface CookiesAgreement {
    revealTimeout: number;
    _isVisible: boolean;
    _timer: NodeJS.Timeout;
}

/**
 * @attr {Number} reveal-timeout - Через сколько секунд сообщение покажется пользователю
 *
 * @slot - Контент в формате HTML
 */
export class CookiesAgreement extends LitElement {
    static get properties() {
        return {
            revealTimeout: {
                type: Number,
                attribute: 'reveal-timeout',
                value: 5000,
            },
            _isVisible: {
                type: Boolean,
                value: false,
            },
        };
    }

    static get styles() {
        return css`
            ${unsafeCSS(_styles)}
        `;
    }

    constructor() {
        super();
        this._acceptCookiesUsage = this._acceptCookiesUsage.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        this._timer = setTimeout(() => {
            this._isVisible = true;
        }, this.revealTimeout);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        clearTimeout(this._timer);
    }

    close() {
        this._isVisible = false;
    }

    protected _acceptCookiesUsage() {
        Cookies.set('COOKIES_USAGE_ACCEPTED', 'true', {
            expires: 365, // days
        });
        this.close();
    }

    protected _onBtnMouseover() {
        (window as any).cursor?.applyHover();
    }

    protected _onBtnMouseleave() {
        (window as any).cursor?.removeHover();
    }

    render() {
        return html`
            <div class="banner ${this._isVisible ? 'banner--visible' : ''}">
                <div class="banner__text">
                    <slot></slot>
                </div>
                <button
                    class="btn btn-primary banner__close"
                    data-text="ОК"
                    @click="${this._acceptCookiesUsage}"
                    @mouseover="${this._onBtnMouseover}"
                    @mouseleave="${this._onBtnMouseleave}"
                    aria-label="Принять и закрыть"
                    title="Принять и закрыть"
                >
                    <span class="btn-inner">ОК</span>
                </button>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'app-cookies-agreement': CookiesAgreement;
    }
}

if (Cookies.get('COOKIES_USAGE_ACCEPTED') !== 'true') {
    customElements.define('app-cookies-agreement', CookiesAgreement);
}
